import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    joinLeague,
} from './../../actions/LeagueActions';
import LeagueShare from './league-share';
import NextBtn from './../onboarding/NextBtn';
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import trackEventsObj from '../../constants/new-pageTrackEvents'

class JoinLeague extends Component {
    setInitialState = () => {
        let LEAGUE_CODE = this.props.readAbleShareLoad;
        LEAGUE_CODE = LEAGUE_CODE || '';
        this.setState({
            leagueCode: LEAGUE_CODE,
            isDisabled: this.isDisabled(LEAGUE_CODE),
            inlineMessage: '',
            showShare: false
        });
    };

    componentWillMount() {
        common.pageViewTracking("", trackEventsObj["joinLeague"]);
        this.setInitialState();
    }



    isDisabled = (value) => {
        return (value.length === 0) ||
            (value.trim().length > config.MAX_LEAGUE_CODE_LENGTH);
    };
    handleChange = (event) => {
        let val = common.validateInput(event.target.value);
        this.setState({ leagueCode: val, isDisabled: this.isDisabled(val) });
    };
    onJoinLeagueBtnTap = () => {
        const GUID = common.getGUID();
        common.showLoader();
        // common.customTracking('Join League');
        this.props.joinLeague(GUID, this.state.leagueCode).then(() => {
            common.hideLoader();
            const response = this.props.joinLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.joinLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('Join League By Code', '/uclfantasy/leagues/');
                common.removeLocalStorage('shareLoad');
                sessionStorage.setItem('joinTeamSuccess', true);
                return this.props.history.push('/league-leaderboard/' + response.Data.Value.LeagueId);
            } else {
                let stateToSet = {
                    inlineMessage: message,
                };
                this.setState(stateToSet);
            }
        });
    };
    onClose = () => {
        common.customTracking('Join League PopUp close icon');
        this.props.onJoinLeagueTap();
    };

    render() {
        const { trans, joinLeagueResponse } = this.props;
        const { inlineMessage, leagueCode, isDisabled, showShare, isJoined } = this.state;
        const nextBtnProps = {
            isDisabled: isDisabled,
            showTitle: isDisabled,
            tooltipText: trans['join_league_cta'],
            text: trans['join_league_cta'],
            handler: () => this.onJoinLeagueBtnTap(),
        };
        const LeagueNameWithError = common.makeClasses({
            'si-league-name': true,
            'si-error': inlineMessage
        });
        let dataToShare = {};
        if (isJoined) {
            dataToShare = (joinLeagueResponse && joinLeagueResponse.Data && joinLeagueResponse.Data.Value);
        }
        return <React.Fragment>
            <div className="si-modal-wrap">
                <div className="si-common-popup si-join-lg">
                    <div className="si-popup-body si-flexBox">
                        <i className="si-close icon-ucl-close" onClick={ () => this.onClose() } />
                        <div className="si-details-wrap">
                            <div className="si-title">
                                { trans['have_an_invite_code'] }
                            </div>
                            <div className={ LeagueNameWithError }>
                                <div className="si-input-wrap">
                                    <input type="text" name="" placeholder={ trans['enter_league_code'] }
                                        maxLength={ config.MAX_LEAGUE_CODE_LENGTH }
                                        value={ leagueCode }
                                        onChange={ (e) => this.handleChange(e) } />
                                </div>
                                { inlineMessage ? <div className="si-error-msg">
                                    <span>{ inlineMessage }</span>
                                </div> : null }
                            </div>
                        </div>
                    </div>
                    <div className="si-popup-btn-wrap">
                        <NextBtn { ...nextBtnProps } />
                    </div>
                </div>
            </div>
            { showShare ? <LeagueShare { ...dataToShare } trans={ trans } toHide={ this.onShareTap.bind(this) } /> : null }
        </React.Fragment>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        joinLeague: (GUID, leagueCode) => dispatch(joinLeague(GUID, leagueCode)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        joinLeagueResponse: state.leaguesData.joinLeagueResponse,
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JoinLeague));


// WEBPACK FOOTER //
// ./src/components/leagues/JoinLeague.js